import { AttachmentsDialog } from "./AttachmentsDialog";
export default AttachmentsDialog;
export * from "./AttachmentsDialog";
